import React, { Suspense } from 'react';

var Visible = function (_a) {
    var when = _a.when, children = _a.children;
    if (!when) {
        return null;
    }
    return React.createElement(Suspense, { fallback: '' }, children);
};

export { Visible as default };
//# sourceMappingURL=Visible.js.map
